// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"2d96d19b","76":"8ee099b8","210":"b0d305dc","243":"03df9823","343":"743b4990","364":"ee959944","433":"3a9225d4","435":"b1eddaf0","484":"68ee8041","487":"0b816247","488":"801ed0f1","529":"923610bf","540":"5f47688b","591":"d825283e","683":"43680012","912":"aaa01a18"}[chunkId] + ".chunk.js";
};